<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 class="text-center" mat-dialog-title i18n="@@rPFavoriteTitle">
  Set removal point has favorite
</h4>

<div mat-dialog-content>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
    <p i18n="@@rPFavoriteMessage">Do you want to pass this removal point as a favorite?</p>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
    <button class="btn btn-danger btn-rounded btn-block" (click)="close(false)" i18n="@@no">No</button>
  </div>

  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
    <button class="btn btn-secondary btn-rounded btn-block" (click)="close(true)" i18n="@@yes">Yes</button>
  </div>
</div>
